import * as React from "react";
import api from "kw/api";
import { policyFields } from "kw/api/fragments";
import { PolicyStatusEnum } from "kw/enums";
import { useGlobal } from "kanopi-components/useGlobal";

const policyLoaderBuilder = (status: PolicyStatusEnum) => {
  return () => {
    const [loading, setLoading] = React.useState(false);
    const [policies, setPolicies] = React.useState([]);
    const [, setProduct] = useGlobal("product");
    React.useEffect(() => {
      async function getPolicies() {
        setLoading(true);

        try {
          const response = await api.query(getPoliciesQuery(status));
          const policies = response?.policies || {};
          setPolicies(policies);
          setProduct({
            key: policies?.[0]?.quote?.product?.key,
          });
        } finally {
          setLoading(false);
        }
      }

      getPolicies();
    }, []);

    return {
      policies: policies,
      loading,
    };
  };
};

export const getPoliciesQuery = (status = PolicyStatusEnum.All) => {
  return {
    policies: [
      {
        status: `"${status}"`,
      },
      {
        ...policyFields,
        riskProfile: undefined,
        quote: {
          ...policyFields.quote,
          riskProfile: undefined,
          covers: undefined,
          limitations: undefined,
        },
        documents: undefined,
      },
    ],
  };
};

export const useActivePolicies = policyLoaderBuilder(PolicyStatusEnum.Active);
export const useInactivePolicies = policyLoaderBuilder(PolicyStatusEnum.Inactive);
export const useAllPolicies = policyLoaderBuilder(PolicyStatusEnum.All);
